export const SET_USER_DATA = "USER_DATA/SET_USER_DATA"
export const SET_USER_PHOTO = "USER_DATA/SET_USER_PHOTO"
